import axios from "axios";
import { supabase } from "../supabaseClient";
import { getBackend } from "../utils/getBackend";
import { getAccessTokenHeader } from "./helper/getAccessTokenHeader";

interface GenerateAltTextRequest {
  imageUrls: string[];
  context?: string;
}

interface GenerateAltTextResponse {
  altTexts: string[];
  error?: string;
}

export async function generateAltText({
  imageUrls,
  context = "",
}: GenerateAltTextRequest): Promise<GenerateAltTextResponse> {
  try {
    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (sessionError || !session) {
      throw new Error("Not authenticated");
    }

    const response = await axios.post(
      getBackend() + "/ai/prompts/alt-text",
      {
        imageUrls,
        context,
      },
      {
        headers: await getAccessTokenHeader(),
      }
    );

    const result = response.data;

    console.log("alt text result", result);

    return result;
  } catch (error) {
    console.error("Failed to generate alt text:", error);
    return {
      altTexts: [],
      error: error instanceof Error ? error.message : "Unknown error",
    };
  }
}
